import React from 'react';
import { connect } from 'react-redux';
import moment from "moment";

import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import WorkReportTemplate from './WorkReportTemplate';
import dailyReportService from '../../services/WorkReport/daily-report-service';
import { 
	fetchLeaderDailyReportList,
	increaseLeaderDailyReportLoadCounter,
	setLeaderDailyReportFilter,
	updateDailyReportStatus
} from '../../actions/work-report-actions';
import { 
	Table,
	Button,
	Modal,
	Spin,
	message,
	Row,
	Col,
	Input,
	Radio,
	DatePicker,
	Form,
	Select
} from 'antd';

const webConfig = require ('../../config.json');

class DailyReportReview extends React.Component {

	rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			let ids = selectedRows.map(row => row.id);
			console.log(ids);
			this.setState({selectedIDs: ids});
		},
		getCheckboxProps: record => ({
			disabled: record.status === 2
		}),
	}

	state = {}

	componentWillMount() {
		if ("loaded" !== this.props.workReport.leaderDailyReportStatus) {
			this.props.increaseLeaderDailyReportLoadCounter();
		}
	}
	componentWillReceiveProps(nextProps) {
		console.log(nextProps);
		if (nextProps.workReport.leaderDailyReportLoadCounter !== this.props.workReport.leaderDailyReportLoadCounter) {
			let gets = {};
			Object.keys(nextProps.workReport.leaderDailyReportFilters).forEach(key => {
				if (nextProps.workReport.leaderDailyReportFilters[key]) {
					gets[key] = nextProps.workReport.leaderDailyReportFilters[key];
				}
			});
			this.props.fetchLeaderDailyReportList(gets);
		}
	}

	setEmployeeFilter = value => {
		this.props.setLeaderDailyReportFilter({real_name: value, code: value, page: 1});
	}

	setStartDateFilter = (value, date) => {
		this.props.setLeaderDailyReportFilter({start_date: date, page: 1});
	}

	setEndDateFilter = (value, date) => {
		this.props.setLeaderDailyReportFilter({end_date: date, page: 1});
	}

	setStatusFilter = event => {
		this.props.setLeaderDailyReportFilter({status: event.target.value, page: 1});
	}

	setPageFilter = pagination => {
		this.props.setLeaderDailyReportFilter({page: pagination.current});
	}

	editReportContent = reportContent => {}

	dailyReportDetail = id => {
		this.setState({currentModalStatus: true});
		dailyReportService.fetchLeaderDailyReportDetail({modelId: id}, res => {
			console.log(res.data);
			this.setState({
				dailyReportTemplate: JSON.parse(res.data.work_report.table_content),
				openDetail: true,
				real_name: res.data.employee.real_name,
				department_name: res.data.employee.department_name,
				position_name:res.data.employee.position_name,
				type_id: res.data.work_report.type_id,
				next_id: res.data.next_id,
				prev_id: res.data.prev_id,
				replies: res.data.replies,
				report_id: res.data.work_report.id,
				currentComment: "",
				report_real_name:res.data.work_report.real_name,
				reprot_department_name:res.data.work_report.department_name,
				report_position_name:res.data.work_report.position_name,
				date_1:res.data.work_report.date_1,
				isAddtion: res.data.work_report.template_name === "小鹿之星",
				currentData: {
					employee_id_1: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_id_1 ? res.data.work_report.best_employees.employee_id_1 : "",
					employee_1_reason: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_1_reason ? res.data.work_report.best_employees.employee_1_reason : "",
					employee_name_1: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_name_1 ? res.data.work_report.best_employees.employee_name_1 : "",
					question: res.data.work_report.question
				},
			});
		});
	}

	setCurrentComment = event => this.setState({currentComment: event.target.value})

	fetchPrevDailyReport = () => this.dailyReportDetail(this.state.prev_id)

	fetchNextDailyReport = () => {
		this.replyDailyReport(() => this.dailyReportDetail(this.state.next_id))
	}

	replyDailyReport = callback => {
		let posts = {
			report_id: this.state.report_id,
			content: this.state.currentComment
		}
		if (posts.content) {
			dailyReportService.replyDailyReport(posts, res => this.replyDailyReportCallback(res, callback));
		}else{
			Modal.confirm({
				title: '您没有填写回复内容，确定要以空内容来回复么？',
				okText: '确认',
				cancelText: '取消',
				onOk: () => dailyReportService.replyDailyReport(posts, res => this.replyDailyReportCallback(res, callback)),
				onCancel: () => {}
			});
		}
	}

	replyDailyReportCallback = (res, callback) => {
		if (res.data.Success) {
			message.success("回复报告成功", 4);
			this.props.increaseLeaderDailyReportLoadCounter();
			this.props.updateDailyReportStatus();
			if ("function" === typeof callback) {
				callback();
			}else{
				this.closeCurrentModal();
			}
		}else{
			message.success("回复报告失败 " + res.data.Errors[0], 4);
		}
	}

	closeCurrentModal = () => {
		this.setState({currentModalStatus: false});
	}

	multiNotifyDailyReport = () => {
		if (!this.state.selectedIDs || 0 === this.state.selectedIDs.length) {
			message.error('请选择需要提醒的报告', 4);
			return;
		}
		if (!this.state.isNotify) {
			this.setState({isNotify: true});
			let posts = {
				report_ids: this.state.selectedIDs
			}
			dailyReportService.multiNotifyDailyReport(posts, res => {
				this.setState({isNotify: false});
				if (res.data.Success) {
					message.success('发送提醒消息成功', 4);
				}else{
					message.error(res.data.Errors[0], 4);
				}
			}, err => {
				message.error("发送提醒消息失败,请联系管理员", 4);
				this.setState({isNotify: false})
			})			
		}
	}

	render() {
		const reportColumn = [{
				title: <div><div>报告人</div><div>Reporter</div></div>,
				dataIndex: 'real_name',
				key: 'real_name',
			}, {
				title: <div><div>报告时间</div><div>Report Time</div></div>,
				dataIndex: 'date_1_str',
				key: 'date_1_str',
			}, {
				title: <div><div>回复时间</div><div>Reply Time</div></div>,
				dataIndex: 'reply_time_str',
				key: 'reply_time_str',
			}, {
				title: <div><div>状态</div><div>Status</div></div>,
				dataIndex: 'status_name',
				key: 'status_name',
			}, {
				title: <div><div>操作</div><div>Action</div></div>,
				dataIndex: 'action',
				key: 'action',
				className: "daily-report-action",
				render: (text, record, index) => (
					<Button icon="info-circle-o" size="small" className="row-action-btn"
						onClick={this.dailyReportDetail.bind(this, record.id)}>详情</Button>
				)
    }];
		const reportsFooter = [
			0 === this.state.prev_id ? null :
			<Button key={1} className="row-action-btn" type="primary"
				onClick={this.fetchPrevDailyReport}>上一条</Button>,
			this.props.access.dailyReportReview.reply_value && (0 === this.state.next_id ?
			<Button key={2} className="row-action-btn" type="primary"
				onClick={this.replyDailyReport}>回复</Button> :
			<Button key={3} className="row-action-btn" type="primary"
				onClick={this.fetchNextDailyReport}>下一条</Button>),
			<Button key={4} className="row-action-btn" type="close"
				onClick={this.closeCurrentModal}>关闭</Button>
		];
		return (
			<div className="app-module-item">
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="&nbsp;"
					maskClosable={false}
					destroyOnClose={true}
					onCancel={this.closeCurrentModal}
					footer={reportsFooter} >
					<div style={{textAlign:"center",margin:"0px 0px 5px",height:"700px",overflowY:"auto"}}>
						{/* <Row style={{fontSize:"16px"}}>
							<Col span={12} style={{height:"40px", lineHeight:"40px",textAlign:"right",paddingRight:"40px"}}>
								<span style={{fontWeight:"bold"}}>报告人 : </span>
								<span style={{color: "blue"}}>{this.state.report_real_name}</span>
							</Col>
							<Col span={12} style={{height:"40px", lineHeight:"40px",textAlign:"left",paddingLeft:"40px"}}>
								<span style={{fontWeight:"bold"}}>部门 : </span>
								<span style={{color: "blue"}}>{this.state.reprot_department_name}</span>
							</Col>
						</Row> */}
						<Row>
							<Col span={18} style={{ fontSize: "32px", height: "95px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Daily Work Report</span><br />
								<span style={{ fontSize: "20px", fontWeight: "bold", paddingLeft: "5px" }}>日工作报告</span>
							</Col>
							<Col span={6} style={{ fontSize: "16px", height: "30px", lineHeight: "30px", textAlign: "right" }}>
								<span style={{}}>{this.state.district}</span>
							</Col>
						</Row>
						<Row style={{ fontSize: "16px", paddingTop: "15px" }}>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Name 姓名 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.report_real_name}</span>
							</Col>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Date 日期 : </span>
								<DatePicker disabled
									value={this.state.date_1 ? moment(this.state.date_1, "YYYY-MM-DD") : null} />
							</Col>
						</Row>
						<Row style={{ fontSize: "16px", paddingBottom: "15px" }}>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Department 部门 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.reprot_department_name}</span>
							</Col>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Position 岗位 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.report_position_name}</span>
							</Col>
						</Row>
						<WorkReportTemplate currentData={this.state.dailyReportTemplate}
							editReportContent={this.editReportContent}
							openDetail={this.state.openDetail} />
							{/* 日报额外添加(小鹿之星) */}
						{this.state.isAddtion &&
							<div>
								<Row style={{ fontSize: "16px", border: "1px solid #cccccc" }}>
									<Col span={24} style={{ height: "40px", lineHeight: "40px", borderWidth: "0px 1px 1px", borderStyle: "solid", borderColor: "#cccccc" }}>
										<div style={{ backgroundColor: "#1a1a1a", minHeight: "40px", lineHeight: "40px", padding: "0px 35px", textAlign: "left", fontSize: "17px", color: "#ffffff" }}>
										请选您心目中的“小鹿之星”并举例说明或分享他的故事
                  </div>
									</Col>

									<Col span={24} style={{ textAlign: "center" }}>
									<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
												<Input value={this.state.currentData && this.state.currentData.employee_name_1} disabled={true} style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
											</div>
											<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
												{/* <Input value={this.state.currentData && this.state.currentData.employee_1_reason} disabled={true} style={{ width: "100%", color: "#000000", backgroundColor: "white" }} /> */}
												<Input.TextArea rows={8}
												value={this.state.currentData && this.state.currentData.employee_1_reason}
												disabled={true}
												style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
											</div>
									</Col>
								
							
								</Row>
								

								<div style={{ height: "10px", border: "0" }}></div>
								<Row style={{ fontSize: "16px", border: "1px solid #cccccc" }}>
									<Col span={24} style={{ height: "40px", lineHeight: "40px", borderWidth: "0px 1px 1px", borderStyle: "solid", borderColor: "#cccccc" }}>
										<div style={{ backgroundColor: "#1a1a1a", minHeight: "40px", lineHeight: "40px", padding: "0px 35px", textAlign: "left", fontSize: "17px", color: "#ffffff" }}>
										问题反馈或给团队的建议(包括学员、家长、与其他部门沟通事项)
                  </div>
									</Col>
									<Col span={24} >
										<div style={{ minHeight: "40px", lineHeight: "40px", border: "1px solid #cccccc" }}>
											<Input.TextArea rows={8}
												value={this.state.currentData && this.state.currentData.question}
												disabled={true}
												style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
										</div>
									</Col>
								</Row>
							</div>
						}
						<div style={{margin:"15px 0px"}}>
							<div style={{textAlign:"left",marginBottom:"15px"}}>请在此回复此报告 : </div>
							<Input.TextArea ref="reportReply" rows={5} value={this.state.currentComment} placeholder="填写回复内容"
								onChange={this.setCurrentComment}></Input.TextArea>
						</div>
						<div style={{textAlign:"left",height: "30px", lineHeight: "30px"}}>
							<p>报告回复列表 : </p>
							{this.state.replies &&
								this.state.replies.map(reply => {
								return (<div key={reply.id}>
									<span style={{color: "blue"}}>{reply.real_name}</span>
									<span> ( </span>
									<span style={{color: "blue"}}>
										{reply.reply_time ? moment(reply.reply_time).format("YYYY-MM-DD HH:MM") : ""}
									</span>
									<span> ) </span>
									<span> 回复 : </span>
									<span>{reply.content}</span>
								</div>)
							})}
						</div>
					</div>
				</Modal>
				<div style={{marginBottom: "20px"}}>
					{/* {this.props.access.dailyReportReview.notify_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button icon="clock-circle-o" type="primary"
							disabled={this.state.isNotify}
							onClick={this.multiNotifyDailyReport}>批量提醒 Batch Remind</Button>
					</div>} */}
					<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Input.Search
							placeholder="报告人 工号/姓名"
							onSearch={this.setEmployeeFilter}
							style={{ width: 200 }}
							defaultValue={this.props.workReport.leaderDailyReportFilters.real_name}
							enterButton />
					</div>
					<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<span style={{marginRight:"5px"}}>开始时间 Start Time: </span>
						<DatePicker onChange={this.setStartDateFilter}
							value={this.props.workReport.leaderDailyReportFilters.start_date ?
							moment(this.props.workReport.leaderDailyReportFilters.start_date) : null} />
					</div>
					<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<span style={{marginRight:"5px"}}>结束时间 End Time: </span>
						<DatePicker onChange={this.setEndDateFilter}
							value={this.props.workReport.leaderDailyReportFilters.end_date ?
							moment(this.props.workReport.leaderDailyReportFilters.end_date) : null} />
					</div>
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<Radio.Group onChange={this.setStatusFilter}
							value={this.props.workReport.leaderDailyReportFilters.status}>
							<Radio.Button value={false}>全部 All</Radio.Button>
							<Radio.Button value="1">未回复 Unreply</Radio.Button>
							<Radio.Button value="2">已回复 Replied</Radio.Button>
						</Radio.Group>
					</div>
					<div style={{clear:"both"}}></div>
				</div>
				{ "loaded" === this.props.workReport.leaderDailyReportStatus && <Table columns={reportColumn} dataSource={this.props.workReport.leaderDailyReportData.Data}
					rowKey={record => record.id} rowSelection={this.rowSelection}
					pagination={{
						total: this.props.workReport.leaderDailyReportData.Total,
						pageSize: this.props.workReport.leaderDailyReportData.PageSize,
						current: this.props.workReport.leaderDailyReportFilters.page}}
					onChange={this.setPageFilter} />}
				{ "unload" === this.props.workReport.leaderDailyReportStatus && <div style={{textAlign:'center', margin: '100px 0px'}}><Spin size="large" /></div>}
				{ "error" === this.props.workReport.leaderDailyReportStatus && <div style={{textAlign:'center', margin: '100px 0px'}}>{webConfig.httpFetchErrorInformation}</div>}
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		workReport: state.workReport,
		isHR: state.user.currentUser.IsHR,
		isLeader: state.user.currentUser.IsLeader
	}
}
const mapDispatchToProps = {
	fetchLeaderDailyReportList,
	increaseLeaderDailyReportLoadCounter,
	setLeaderDailyReportFilter,
	updateDailyReportStatus
}
DailyReportReview = Form.create()(DailyReportReview);
export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(DailyReportReview));





// WEBPACK FOOTER //
// ./src/routes/WorkReport/DailyReportReview.js